import React, {PureComponent} from 'react';
import NavItems from './NavItems';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { NavItem } from './NavItem';
import { motion, useScroll, useSpring, useTransform } from "motion/react";
import navState from './navState';
import globalActivityState from '../../../model/globalActivityState';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import navUtil from './navUtil';
import themeManager from '../common/theme/themeManager';
import logo from '../logo/logo.png';
import logoDark from '../logo/logo-dark.png';
import '../StylesGlassNav.css';

const ScrollIndicator = () => {
  const { scrollYProgress } = useScroll();
  
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      id="scroll-indicator"
      style={{
        scaleX,
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: 3,
        originX: 0,
        backgroundColor: "#936E4E",
        zIndex: 1100,
      }}
    />
  );
};

interface Props { }

interface State {
  currentContentNavItem: NavItem
  busy: boolean
  currentTheme: string
  isMobileMenuOpen: boolean
}

export default class TopNavigation extends PureComponent<Props, State> {

  active: boolean = false;
  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      currentContentNavItem: navState.getCurrentContentNavItem(),
      busy: globalActivityState.isBusy(),
      currentTheme: themeManager.getCurrentTheme(),
      isMobileMenuOpen: false
    };
  }

  componentDidMount() {
    this.active = true;
    navState.registerListener(this.onNavStateChange);
    globalActivityState.registerListener(this.onGlobalActivityStateChange);
  }

  componentWillUnmount() {
    this.active = false;
    navState.unregisterListener(this.onNavStateChange);
    globalActivityState.unregisterListener(this.onGlobalActivityStateChange);
  }

  onNavStateChange = (navItem: NavItem) => {
    if (this.active) {
      this.setState({
        currentContentNavItem: navItem
      });
    }
  }

  onGlobalActivityStateChange = () => {
    if (this.active) {
      this.setState({
        busy: globalActivityState.isBusy()
      });
    }
  }

  toggleMobileMenu = () => {
    this.setState((prevState) => ({
      isMobileMenuOpen: !prevState.isMobileMenuOpen
    }));
  }

  onNavItemClicked = (navItem: NavItem) => {
    const contentNavItem = navUtil.navItemAsContentNavItem(navItem);
    if (contentNavItem) {
      this.setState({ isMobileMenuOpen: false });
      if (navItem.renderInModal) {
        navState.setModalNavItem(contentNavItem);
      } else {
        navState.setLocation(contentNavItem);
      }
    }
  }

  renderGlassNavItem = (navItem: NavItem) => {
    if (navItem.discoverable) {
      const isSelected = navState.isSelected(navItem);
      const classNames = `glass-nav-item ${isSelected ? 'selected' : ''}`;
      return (
        <button
          key={`${navItem.key}`}
          className={classNames}
          onClick={() => this.onNavItemClicked(navItem)}
        >
          {navItem.name}
        </button>
      );
    } else {
      return null;
    }
  }

  renderGlassNavItems = () => {
    return NavItems.getTopLevelNavItems().map((navItem) => {
      return this.renderGlassNavItem(navItem);
    });
  }

  render() {
    const currentThemeName = this.state.currentTheme === 'dark' ? 'Dark' : 'Light';

    return (
      <>
      <ScrollIndicator />
      
        <div className="mobile-top-bar">
          <a 
            href="/" 
            className="glass-side-button left brand-button"
          >
            <span className="brand-text">Luca Morrow</span>
            <img src={currentThemeName === 'Dark' ? logo : logoDark} className="brand-logo" alt="Luca Morrow logo" />
          </a>

          <div className="glass-nav-container mobile-nav-container">
            <nav className={`glass-nav ${this.state.isMobileMenuOpen ? 'mobile-open' : ''}`}>
              <button
                className="glass-nav-hamburger"
                onClick={this.toggleMobileMenu}
                aria-label="Toggle navigation"
                aria-expanded={this.state.isMobileMenuOpen}
              >
                <span />
                <span />
                <span />
              </button>
              <div className="glass-nav-links">
                {this.renderGlassNavItems()}
              </div>
            </nav>
          </div>

          <button 
            className="glass-side-button right mobile-theme-button"
            onClick={() => {
              themeManager.toggleTheme(); 
              this.setState({ currentTheme: themeManager.getCurrentTheme() });
              if(navState.currentContentNavItem?.key === 'modelling3d') {
                window.location.reload();
              }
            }}
          >
            {currentThemeName}
          </button>
        </div>

        <div className="desktop-nav-shell">
          <div className="glass-nav-container">
            <nav className={`glass-nav ${this.state.isMobileMenuOpen ? 'mobile-open' : ''}`}>
              <button
                className="glass-nav-hamburger"
                onClick={this.toggleMobileMenu}
                aria-label="Toggle navigation"
                aria-expanded={this.state.isMobileMenuOpen}
              >
                <span />
                <span />
                <span />
              </button>
              <div className="glass-nav-links">
                {this.renderGlassNavItems()}
              </div>
            </nav>
          </div>

          <a 
            href="/" 
            className="glass-side-button left brand-button"
          >
            <span className="brand-text">Luca Morrow</span>
            <img src={currentThemeName === 'Dark' ? logo : logoDark} className="brand-logo" alt="Luca Morrow logo" />
          </a>

          <button 
            className="glass-side-button right"
            onClick={() => {
              themeManager.toggleTheme(); 
              this.setState({ currentTheme: themeManager.getCurrentTheme() });
              if(navState.currentContentNavItem?.key === 'modelling3d') {
                window.location.reload();
              }
            }}
          >
            {currentThemeName}
          </button>
        </div>
      </>
    );
  }

}
